export default __webpack_public_path__ + "static/flinders-1-7280bd4f8c483efd297a21ede570f921.jpg";